import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import React from 'react';
import {loginStep} from './variables';

const Footer = (props) => {
  let text = '';
  switch (props.stage) {
    case loginStep.CODE:
    case loginStep.SELECTLOBBY:
    case loginStep.SELECTPRIVATE:
    case loginStep.OTP:
    case loginStep.ID:
    case loginStep.TERMS:
    case loginStep.PAYPAL_EMAIL:
    case loginStep.DIGITS:
    case loginStep.PHONE: {
      text = 'בואו נתקדם';
      break;
    }
    case loginStep.ERROR:
    case loginStep.GENERALERROR:
    case loginStep.TALKMANERROR:
    case loginStep.NOPRIMARYERROR:
    default: {
      text = 'לעמוד הבית';
      break;
    }
  }
  return (
    <div className='footer'>
      <BtnSubmit
        text={text}
        className='continueButton'
        onclick={async () => {
          await props.onclick();
        }}
      />
    </div>
  );
};

export default Footer;
